module.exports = __webpack_public_path__ + "img/stethoscope.ea441e2b.svg";